import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { bifoldAlumStiles } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { Image } from "cloudinary-react";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const BifoldProfiles:  FC = () => {
    const { readOnly } = useIsReadOnlyContextProviderContext();
  return (
    <ReusableAccordian
      accordionName="stilesRailsProfile"
      heading={"Stiles and Rails Profile"}
      secondaryHeading="Select profile"
      colOrRow="col"
    >
      <ColLayout>
        <RowLayout style={{ paddingBottom: 20 }}>
          {bifoldAlumStiles.map((state) => (
            <div key={state.id}>
              <Choices
                label={state.label}
                variant={"filled"}
                checkMark={true}
                disabled={true}
                wide={true}
              />
            </div>
          ))}
        </RowLayout>

        <Image
          cloudName="ag-millworks"
          secure="true"
          publicId={"Frame_Profile/Bifold/AA_Bifold_Stile"}
        />
      </ColLayout>
    </ReusableAccordian>
  );
};

export default memo(BifoldProfiles);
